//Redux
import { combineReducers } from "redux";

//Reducers
import appReducer from "./appReducer";
import dataReducer from "./dataReducer";
import formsReducer from "./formReducer";
import logsReducer from "./logsReducer";
import menuReducer from "./menuReducer";
import snackbarReducer from "./snackbarReducer";
import userReducer from "./userReducer";
import { routerReducer } from "react-router-redux";

//Dev
import tempReducer from "./tempReducer";

export default combineReducers({
  app: appReducer,
  data: dataReducer,
  forms: formsReducer,
  logs: logsReducer,
  menu: menuReducer,
  router: routerReducer,
  snackbar: snackbarReducer,
  user: userReducer,
  //Dev
  temp: tempReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js